import styled from 'styled-components';
import { black } from '../../../utils/style/colors';

export const SearchHolder = styled.div`
  border: 1px ${black} solid;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: end;
  padding: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  & > * {
    flex-grow: 1;
    flex-basis: 0;
    margin: 0 10px;
  }
`;
